import { ManageResourceGroupsDialog } from './ManageResourceGroupsDialog';
import { useGroupSecurityDialogStore } from '../stores/group-security-dialog-store';

/**
 * Single mount point for the Group Security "manage this resource's groups" dialog. Rendered once
 * in AppShell; any content 3-dots menu opens it via `useGroupSecurityDialogStore().openManageGroups`.
 */
export function GroupSecurityDialogHost() {
  const target = useGroupSecurityDialogStore((s) => s.target);
  const close = useGroupSecurityDialogStore((s) => s.close);

  if (!target) return null;

  return (
    <ManageResourceGroupsDialog
      resourceType={target.resourceType}
      resourceId={target.resourceId}
      teamId={target.teamId}
      resourceName={target.resourceName}
      onClose={close}
    />
  );
}
